import { render, staticRenderFns } from "./main-section-itemsbelongings-ccan.vue?vue&type=template&id=ad53d53e&scoped=true"
import script from "./main-section-itemsbelongings-ccan.vue?vue&type=script&lang=js"
export * from "./main-section-itemsbelongings-ccan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad53d53e",
  null
  
)

export default component.exports